import { Box } from "@mui/material"
import { useAppSelector } from "../../app/hooks"
import { impossible } from "../../app/Utils"
import { ApprovalCardViewWrapper } from "./components/ApprovalCardViewWrapper"
import { ResponsibilitiesSectionWrapper } from "./components/ResponsibilitiesSectionWrapper"
import { DocumentAttachmentsWrapper } from "./documentAttachments/DocumentAttachmentsWrapper"
import { DocumentDqMappingsViewWrapper } from "./documentDqMappings/DocumentDqMappingsViewWrapper"
import { DocumentHistorySectionWrapper } from "./documentHistory/DocumentHistorySectionWrapper"
import { DocumentQuestionViewWrapper } from "./documentQuestions/DocumentQuestionViewWrapper"
import { sectionSelectors, showDocComments } from "./documentSlice"
import { DocumentTestWrapper } from "./documentTests/DocumentTestWrapper"
import { DocumentTestTeamWrapper } from "./documentTestTeam/DocumentTestTeamWrapper"
import { LimitsSection } from "./riskAnalysis/LimitsSection"
import { MitigationScheduleSection } from "./riskAnalysis/MitigationScheduleSection"
import { RecommendedActionSection } from "./riskAnalysis/RecommendedActionsSection"
import { SectionComments } from "./SectionComments"
import { SectionContent } from "./SectionContent"
import { DocumentDeviationSectionWrapper } from "./sections/deviationsSection/DocumentDeviationSectionWrapper"
import { DocReferencesSectionView } from "./sections/docReferencesSection/DocReferencesSectionView"
import { DocumentValidationTeamWrapper } from "./sections/DocumentValidationTeam"
import { DocumentScheduleTestSectionWrapper } from "./sections/scheduleSection/DocumentScheduleTestSectionWrapper"
import { DocumentTestMethodologySectionWrapper } from "./sections/testMethodologySection/DocumentTestMethodologySectionWrapper"
import { ValidatedObjectSectionWrapper } from "./sections/validatedObjectSection/ValidatedObjectSectionWrapper"
import { RiskAnalysisSummarySectionWrapper } from "./riskAnalysis/sections/RiskAnalysisSummarySectionWrapper"
import { FormSectionWrapper } from "./sections/formSection/FormSectionWrapper"

export const SectionContentDispatcher = (props: { sectionId: string }) => {
    const { sectionId } = props
    const section = useAppSelector(state => sectionSelectors.selectById(state, sectionId)) ?? impossible()
    const { type } = section
    const showComments = useAppSelector(state => showDocComments(state, sectionId))

    switch (type) {
        case 'GROUP':
            return showComments ? <SectionComments sectionId={sectionId} contextType='' contextGuid={null} /> : <SectionContent sectionId={sectionId} actions={<></>} />
        case 'VERSIONS_HISTORY':
            return <DocumentHistorySectionWrapper sectionId={sectionId} />
        case 'APPROVAL_CARD':
            return showComments ? <SectionComments sectionId={sectionId} contextType='' contextGuid={null} component={<ApprovalCardViewWrapper sectionId={sectionId} />} /> : <ApprovalCardViewWrapper sectionId={sectionId} />
        case 'RESPONSIBILITIES':
            return showComments ? <SectionComments sectionId={sectionId} contextType='' contextGuid={null} /> : <ResponsibilitiesSectionWrapper sectionId={sectionId} />
        case 'VALIDATION_TEAM':
            return showComments ? <SectionComments sectionId={sectionId} contextType='' contextGuid={null} /> : <DocumentValidationTeamWrapper sectionId={sectionId} />
        case 'QUESTIONS_WITH_LIST':
            return <DocumentQuestionViewWrapper sectionId={sectionId} />
        case 'TESTS':
            return <DocumentTestWrapper sectionId={sectionId} />
        case 'TESTS_TEAM':
            return <DocumentTestTeamWrapper sectionId={sectionId} />
        case 'DQ_MAPPINGS':
            return <DocumentDqMappingsViewWrapper sectionId={sectionId} />
        case 'VALIDATED_OBJECT':
            return <ValidatedObjectSectionWrapper sectionId={sectionId} />
        case 'TESTS_SCHEDULE':
            return <DocumentScheduleTestSectionWrapper sectionId={sectionId} />
        case 'TESTS_METHODOLOGY':
            return <DocumentTestMethodologySectionWrapper sectionId={sectionId} />
        case 'DEVIATIONS':
            return <DocumentDeviationSectionWrapper sectionId={sectionId} />
        case 'ATTACHMENTS':
            return <DocumentAttachmentsWrapper sectionId={sectionId} />
        case 'RISK_ANALYSIS':
            return null
        case 'REQUIREMENTS':
            return null
        case "RA_MITIGATION_SCHEDULE":
            const mss = <MitigationScheduleSection sectionId={sectionId} />
            return showComments ? <SectionComments sectionId={sectionId} contextType='' contextGuid={null} component={<Box>{mss}</Box>} /> : mss
        case "RA_RECOMMENDED_ACTIONS":
            const ras = <RecommendedActionSection sectionId={sectionId} />
            return showComments ? <SectionComments sectionId={sectionId} contextType='' contextGuid={null} component={<Box>{ras}</Box>} /> : ras
        case "RA_LIMITS":
            const ls = <LimitsSection sectionId={sectionId} />
            return showComments ? <SectionComments sectionId={sectionId} contextType='' contextGuid={null} component={<Box>{ls}</Box>} /> : ls
        case "DOC_REFERENCES":
            const drs = <DocReferencesSectionView sectionId={sectionId} />
            return showComments ? <SectionComments sectionId={sectionId} contextType='' contextGuid={null} component={<Box>{drs}</Box>} /> : drs
        case "RA_SUMMARY":
            const rasum = <RiskAnalysisSummarySectionWrapper sectionId={sectionId} />
            return showComments ? <SectionComments sectionId={sectionId} contextType='' contextGuid={null} component={<Box>{rasum}</Box>} /> : rasum
        case "FORM":
            const form = <FormSectionWrapper sectionId={sectionId} />
            return showComments ? <SectionComments sectionId={sectionId} contextType='' contextGuid={null} component={<Box>{form}</Box>} /> : form
    }
}
